import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container'




export default function AddWebsiteLayoutComponent ({handleInnerFormChange, selectedLayouts}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Layout Name"
              name="LayoutName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LayoutName',

                )
              }}
              type="text"
              value={selectedLayouts?.LayoutName}
          />
           <InputContainer
              label="LayoutVersionId"
              name="LayoutVersionId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LayoutVersionId',

                )
              }}
              type="number"
              value={selectedLayouts?.LayoutVersionId}
          />
        <InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedLayouts?.Remarks}
/>
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}